import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { select, Store } from '@ngrx/store';
import { ConfirmActionDialogComponent } from '../../crud';
import { currentAuthToken } from '../../../../../core/auth';
import { AppState } from '../../../../../core/reducers';

@Component({
  selector: 'kt-picture-cropper',
  templateUrl: './picture-cropper.component.html',
  styleUrls: ['./picture-cropper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class PictureCropperComponent implements AfterViewInit {
  croppedImage: any = '';
  imageChangedEvent: any = '';
  files = [];
  base64String: any;
  existImage;
  default;
  authToken;
  mode = '';
  editable = false;
  loading = false;
  desiredRatioDen = 0.91;
  desiredRatioDiv = 1;

  constructor(
    public dialogRef: MatDialogRef<PictureCropperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.existImage = this.default = this.data.defaultImage;
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    if (this.data.existImage) {
      this.existImage = this.data.existImage;
      this.editable = true;
    }
    this.mode = this.data.mode;
  }

  ngAfterViewInit(): void {
    this.toDataURL(this.existImage, (res) => {
      this.base64String = res;
    });
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.loading = true;
  }

  imageLoaded() {
    // show cropper
  }
  get desiredRatio(): number {
    return this.desiredRatioDen / this.desiredRatioDiv;
  }
  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  save() {
    this.dialogRef.close({ img: this.croppedImage, files: this.files, mode: this.mode });
  }

  imageChanged($event) {
    this.imageChangedEvent = $event;
    this.files = [];
    for (const file of $event.target.files) {
      this.files.push(file);
    }
    this.editable = true;
    this.mode = 'UPDATE';
  }

  toDataURL(url, callback) {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);

    xhr.setRequestHeader('Cache-Control', 'no-cache');
    xhr.setRequestHeader('Pragma', 'no-cache');
    xhr.setRequestHeader('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
    xhr.responseType = 'blob';
    xhr.send();
  }

  RemovePicture() {
    const dialogRef = this.dialog.open(ConfirmActionDialogComponent, {
      data: {
        title: 'Remove Picture',
        description: 'Are you sure you want to remove it?',
        waitDesciption: 'Removing ...',
      },
      width: '440px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }
      this.existImage = this.default;
      this.editable = false;
      this.base64String = this.existImage;
      this.mode = 'DELETE';
      this.cdr.detectChanges();
    });
  }
}
